export default "__VITE_ASSET__a697a494__"